import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { Modal } from '@ui/components/Modal'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { DocumentCategoryType } from '@model/DocumentCategories'
import { NameDto } from '@model/NameDto'

interface DocumentManagementIdentificationModalProps {
  documentCategoryType: DocumentCategoryType

  onSelectOption(category: NameDto<DocumentCategoryType>, type: NameDto): void

  onCancel?: () => void
}

export const DocumentManagementCategoryModal: BaseModalType<
  DocumentManagementIdentificationModalProps
> = ({ close, documentCategoryType, onSelectOption, onCancel }) => {
  const { t } = useTranslation()
  const apiClient = useApiClient(ClientApiClient)
  const locale = useSessionLanguage()

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.document.categories(documentCategoryType, locale),
    queryFn: () => apiClient.getDocumentCategories(documentCategoryType, locale),
  })

  const handleSelectOption = (documentCategory: NameDto) => {
    if (data) {
      onSelectOption(data.category, documentCategory)
      close()
    }
  }

  return (
    <Modal>
      <Modal.Header>{t('Profile.Document Type')}</Modal.Header>
      <Modal.Body isLoading={isLoading}>
        {data?.types && data.types.length > 0 && (
          <Modal.Body.Input.Radio
            name='document-category-type'
            options={data.types.map((x) => ({ label: x.name, value: String(x.id) }))}
            onChange={(id: string) =>
              handleSelectOption(data.types.find((x) => String(x.id) === id) as NameDto)
            }
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary
          onClick={() => {
            onCancel?.()
            close()
          }}
        >
          {t('Cancel')}
        </Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
